export default __webpack_public_path__ + "automationAPIArch.3b1609b5.png";